import axios from 'axios'

const server = 'http://jiananzb.w11-e1.ezwebtest.com/cannan_api/api'

const account = {
  state: {
    userData: [],
    homeInvest: [],
    travel: [],
    travelInfo: [],
    fundAccounce: [],
    homeAccounce: [],
    uploadImg: [],
  },
  mutations: {
    getUserData(state, data) {
      state.userData = data
    },
    getHomeInvest(state, data) {
      state.homeInvest = data
    },
    getTravel(state, data) {
      state.travel = data
    },
    getTravelInfo(state, data) {
      state.travelInfo = data
    },
    getFundAccounce(state, data) {
      state.fundAccounce = data
    },
    getHomeAccounce(state, data) {
      state.homeAccounce = data
    },
    uploadImg(state, data) {
      state.uploadImgData = data
    }
  },
  actions: {
    getUserData(context, data) {
      return new Promise((resolve) => {
        axios.post(`${server}/account/userData`, data).then((response) => {
          context.commit('getUserData', response.data)
          resolve()
        })
      })
    },
    getHomeInvest(context, data) {
      return new Promise((resolve) => {
        axios.post(`${server}/account/homeInvest`, data).then((response) => {
          context.commit('getHomeInvest', response.data)
          resolve()
        })
      })
    },
    updateUserData(context, data) {
      return new Promise((resolve) => {
        axios.put(`${server}/account/userData/${data.id}`, data).then((response) => {
          resolve()
        })
      })
    },
    getTravel(context, data) {
      return new Promise((resolve) => {
        axios.get(`${server}/front/travel`).then((response) => {
          context.commit('getTravel', response.data)
          resolve()
        })
      })
    },
    getTravelInfo(context, data) {
      return new Promise((resolve) => {
        axios.get(`${server}/front/travel/${data.id}`).then((response) => {
          context.commit('getTravelInfo', response.data)
          resolve()
        })
      })
    },
    getFundAccounce(context, data) {
      return new Promise((resolve) => {
        axios.get(`${server}/account/fundAccounce`).then((response) => {
          context.commit('getFundAccounce', response.data)
          resolve()
        })
      })
    },
    getHomeAccounce(context, data) {
      return new Promise((resolve) => {
        axios.get(`${server}/account/homeAccounce`).then((response) => {
          context.commit('getHomeAccounce', response.data)
          resolve()
        })
      })
    },
    // 上傳圖片
    uploadImg(context, data) {
      return new Promise((resolve) => {
        axios.post(`${server}/uploadImg`, data, {
          'Content-Type': 'multipart/form-data'
        }).then((response) => {
          context.commit('uploadImg', response.data)
          resolve()
        })
      })
    }
  }
}
export default account
